import { render, staticRenderFns } from "./BannerComponents.vue?vue&type=template&id=81bc3ba6"
import script from "./BannerComponents.vue?vue&type=script&lang=js"
export * from "./BannerComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports